export default {
  black: {
    dark: `#000`,
    base: `#333`
  },
  white: {
    light: `#fff`
  }
}
